export default {
  //关于我们
  about: {
    aboutUs: "关于我们",
    des1: " 薄盒Mints是北京擘盒科技有限公司旗下数字潮玩收藏平台，基于区块链技术确权数字内容，提供可信存证技术、藏品数字凭证技术服务。通过生活中随处可见的智能手机和电子屏，重新定义新的收藏方式。致力于持续提升数字资产的消费和收藏互动体验。",
    des2: "联系电话：",
    des3: "联系邮箱：",
  },
  // activationcode: {
  //   //兑换码页面
  //   title: "兑换码",
  //   describe: "请输入16位兑换码进行兑换",
  //   placeholder: "请输入兑换码",
  //   activationBtn: "立即兑换",
  //   service: "咨询客服",
  //   ruleTitle: "兑换码规则",
  //   rule1: "1、请先完成实名认证，仅支持年满18周岁的用户。",
  //   rule1: "2、输入正确的兑换码后，可获得对应数字资产。",
  //   rule1: "3、一个兑换码仅限兑换一次，不可重复使用。",
  //   status_text: "恭喜您兑换成功！",
  //   look_certificate: "查看证书",
  //   purchaseInstructionsP1: "数字证书说明",
  //   purchaseInstructionsP2: "请您务必审慎阅读 充分理解以下内容",
  //   p4Des1: "立足于通过数字证书进行商品防伪溯源，保护正版价值。",
  //   p4Des2: "数字证书不具备交易价值，仅为确权工具，不允许炒作。",
  //   p4Des3: "本数字证书不得用于炒作、场外交易和任何商业用途。如发现存在炒作等异常行为、涉嫌违法违规或协议禁止的行为，我们有权采取必要的限制措施，包含但不限于冻结账号等。",
  //   p4Des4: "请远离非理性炒作，防范欺诈风险。",
  //   p4Des5: "立足于通过数字证书进行商品防伪溯源，保护正版价值。",
  //   p4Des6: "数字证书不具备交易价值，仅为确权工具，不允许炒作。",
  //   p4Des7: "本数字证书可支持赠送，赠送程序需依据国家法律法规和政策不定期调整。",
  //   p4Des8: "本数字证书不得用于炒作、场外交易和任何商业用途。如发现存在炒作等异常行为、涉嫌违法违规或协议禁止的行为，我们有权采取必要的限制措施，包含但不限于冻结账号等。",
  //   p4Des9: "请远离非理性炒作，防范欺诈风险。",
  //   p4Des10: "立足于通过数字证书进行商品防伪溯源，保护正版价值。",
  //   p4Des11: "数字证书不具备交易价值，仅为确权工具，不允许炒作。",
  //   p4Des12: "为了防止炒作，本数字证书需至少持有达到",
  //   p4Des122: "天后可无偿赠送，赠送程序需依据国家法律法规和政策不定期调整。",
  //   p4Des13: "本数字证书不得用于炒作、场外交易和任何商业用途。如发现存在炒作等异常行为、涉嫌违法违规或协议禁止的行为，我们有权采取必要的限制措施，包含但不限于冻结账号等。",
  //   p4Des14: "请远离非理性炒作，防范欺诈风险。",
  //   refuseBtn: "取消",
  //   agreeBtn: "兑换",
  //   agreeBtn1: "兑换",

  // },
  bankAgreement: {
    //兑协议页面
  },
  blindbox: {
    //快速了解数字资产页面
    Noviceguide: "新手指南",
    commonProblem: "常见问题",
    blindboxDes1: "来薄盒，构建属于自己的下一代可视化数字身份，开启web3之旅！",
    blindboxDes2: "薄盒Mints为国内首个基于web3网络框架，集可穿戴数字资产与藏品应用场景于一体的入口。通过区块链技术确权数字内容，提供可信存证技术、藏品数字凭证技术服务，通过生活中随处可见的智能手机和电子屏，重新定义新的收藏方式。特別一提，薄盒除了致力于持续提升藏品消费和收藏互动体验，更主力推动可视化数字身份体系的构建，和知名品牌联合打造多面向可穿戴数字资产。并以具有惊喜的盲盒形式为藏家们带來不同的体验。",
    blindboxDes3: "独家正版授权，权威、可信赖！",
    blindboxDes4: "平台聚合开发顶流品牌资源，限量发行正版授权可穿戴的数字资产。让每个人都有机会拥有独一无二的数字资产，获得更多平台或品牌专属权益。在这里，无论你是创作者还是数字资产的收藏家，薄盒都会为您带来更自由的选择。为每一位用户拓展更丰富更酷的玩法。",

    blindboxDes6: "什么是下一代数字收藏",
    blindboxDes7: "下一代数字收藏，亦称数字资产2.0，薄盒Mints作为国内首家数字资产2.0的开拓者，快速开启数藏收藏应用时代，加快了行业创新与资源整合。让藏品可应用于虚拟与现实，将各领域(电影、电视剧、综艺、动漫、音乐、艺术品)且多元的优秀品牌铸造成可应用的数字资产，放入数字盲盒独家限量发售，赋能成为在元宇宙中可穿戴的物件及可置换的全息场景空间，在无界限的数字世界里享受创作、藏品展示、娱乐休闲、社交互动的深度体验。 ",

    blindboxDes9: "打造独一无二的元宇宙化身",
    blindboxDes10: "我们为每个用户打造专属于个人的数字身份并将其3D数字人化，在这里获得的所有数字资产都将可能拥有可穿戴属性，创建专属于你的元宇宙数字人，将各种藏品穿戴在你的虚拟形象上，与好友分享炫耀数字世界或现实生活的数字时尚创意，让元宇宙中的你被各领域知名品牌赋能，在现实和元宇宙中焕发新的生命力！",
    blindboxDes12: "AR投射将藏品融入现实生活",
    blindboxDes13: "通过优质的品牌资源让多个内容组合，在物理世界之上建设一个平行的虚拟世界！打开AR摄像头，将藏品放在真实世界中，创造数字技术带来的全新造型风格并分享至各大社交平台，建立与众不同的数字时尚情感链接，获得物理与数字交融的双重体验。",
    blindboxDes131: "获取元宇宙中的数字名片与成就",
    blindboxDes132: "不仅仅是虚拟形象的塑造，薄盒Mints特有的MNS（基于区块链的可扩展和开放式化的命名系统）让你拥有不可替代、不可重复的数字身份名片；POAP链上徽章把你在数字世界的成就、贡献、兴趣、活动相绑定，来证明你在元宇宙世界中的身份和位置，不但成为你数字资产的一部分也能帮你快捷找到属于自己的同好，随时随地随心交流，体验元宇宙时代的全新社交体验。",
    blindboxDes133: "为什么要建立自己的数字身份？",
    blindboxDes134: "数字身份一直都是互联网链接用户与平台的唯一标识。Web1只读时代，用户通过账号注册获取不具有实际用途的身份体系；“可读可写”的Web2阶段，用户在可通过注册创建身份的同时，还能一键授权登录创建身份。而随着“可读可写且可拥有”Web3时代的到来，如数字资产、3D数字人等成为了数字身份的新一代创建方式，也是通往不同虚拟空间的通行证。不仅如此，Web3时代下的数字身份可让用户完全拥有自己身份信息的所有权及产生数据的自主权。",
    blindboxDes135: "在这里，收集可穿戴的数字资产！ ",
    blindboxDes136: "因为数字资产具有不可篡改、不可分割、不可复制的属性以及不受题材、展示方式、现实物理法则约束的特性，所以它拥有无限的可能性。在未来，你可操作你由数字资产组成的数字人在虚拟空间中与其他人聊天社交；也可以将影视剧中的服饰、道具、饰品等主题数字资产着装在数字人身上，让你的数字人拥有犹如主角一般的形象，更可以拥有坐骑以及各种稀有交通工具数字资产，让你可以与之互动在虚拟空间中穿梭。除此之外，还可以拥有属于自己的宠物数字资产，陪伴你左右。现在，这一切正在逐步实现，薄盒Mints致力于实现数字资产的每一种可能，把未来带入现实。",
    blindboxDes137: "丰富多彩的藏品获取方式",
    blindboxDes138: "在薄盒Mints您可以拥有多种获取数字资产的方式，可以通过开启趣味盲盒、参与平台活动等多种形式来获得数字资产。目前平台所有的数字资产仅支持人民币支付，且只允许中国用户购买。",
    blindboxDes139: "平台特有的藏品打开仪式",
    blindboxDes140: "比起直接购买已知内容物的数字资产，盲盒形式让收藏的过程充满了惊喜和乐趣，通过购买盲盒的方式可以让收藏者发现更多可能从未注意过或是限量珍藏的优质数字资产，也可能获得比盲盒本身价值更高的数字资产。每个盲盒都是和品牌方联合制造及取得官方授权，内含数字资产皆属于该主题藏品，购买盲盒更有机会获得稀有款数字资产。",
    blindboxDes14: "我们欢迎您，",
    blindboxDes15: "欢迎来到薄盒，更欢迎来到未来，",
    blindboxDes16: "在这里成为独一无二的数字资产收藏家。",
    blindboxDes17: "如何购买数字资产盲盒？",
    blindboxDes18: "通过“首页”或“盲盒”导航页面，进入盲盒详情；",
    blindboxDes19: "等候室开放后点击“加入等候室”，待盲盒发售时间，系统会自动随机分配排队号码，用户根据号码进行排队购买；",
    blindboxDes20: "进入购买页面后，用户完成支付，则可以直接打开盲盒获取数字资产，也可以后期在个人中心中完成开启盲盒的操作；",
    blindboxDes21: "打开盲盒后立即获得数字资产，可以在“个人中心”里随时看到已经获得的数字资产。",
    blindboxDes22: "目前仅支持人民币购买，支持使用微信或支付宝支付。目前只允许中国用户购买。针对盲盒和数字资产的交易过程会记录在区块链上，所以概不支持退款。",
    blindboxDes23: "如何创建自己的元宇宙3D数字人？",
    blindboxDes24: "目前数字人系统仅支持薄盒Mints App内创建并查看。下载薄盒App并完成注册后，点击个人中心自动跳转创建数字人的界面，选择性别点击下一步，完成捏脸并保存，即可拥有专属数字人。",
    blindboxDes25: "如何调整数字人穿戴及造型？",
    blindboxDes26: "成功拥有数字人之后，点击进入个人中心看到选择数字人边上的",

    blindboxDes27: "按钮，进入数字人衣柜。进入之后可以选择已获得的所有可穿戴数字资产穿戴在数字人身上。右上角选择",
    blindboxDes28: "按钮可进入捏脸页面，调整数字人形象。选择右下角",
    blindboxDes29: "按钮可更换数字人性别或已获得的其他角色形象。",
    blindboxDes30: "MNS是什么？",
    blindboxDes31: "「MNS」是Mints Name Service缩写，它是一个基于区块链技术的可扩展命名系统，主要服务于用户可读区块链地址映射名称，让人们没有必要再复制或输入冗长的区块链地址来作为访问的链接或身份标识内容。每一枚「MNS」本身也将会是一个独一无二的数字资产，具有数字资产属性。",
    blindboxDes32: "积分是什么？",
    blindboxDes33: "在平台购买盲盒或者参与活动都会获得相应的积分。目前积分功能还未全面上线，具体使用方式和规则会在后续逐步更新。",
    blindboxDes35: "POAP是什么?",
    blindboxDes36: "POAP也称“出勤证明协议”，它将会是你在元宇宙世界中的出行见证，每一枚POAP皆是通过特别设计的徽章，用户可以通过POAP来证明自己的链上行为并永恒记录在时间戳上，让用户之间可以快捷的找到属于自己的同好。在未来POAP更具极大可能性演变成有价值的收藏品。",
    blindboxDes37: "如何赠送藏品",
    blindboxDes38: "部分数字资产支持赠送，在购买时会在盲盒详情中标注是否支持赠送。请注意查看；",
    blindboxDes39: "如数字资产可赠送，在数字资产的商品页面，选择赠送按钮，填写需要赠送的人的手机号及信息将页面转发给即可。被赠人点击注册后即可领取赠品。"
  },
  infiniteBoxDetail: {
    buy: "立即购买",
    moreBuy: "剩余最多购买数量",
    count: "数量",
    selectCount: "选择数量",
    youzan: {
      text: "下单支付成功后，请前往个人中心查看我的盲盒。",
      btn: "关闭",
      btn2: "去查看",
    }
  },
  public: {
    money: "￥",
    endLine: "这是我的底线",
    qx: "取消",
    qr: "确认",
    qd: "确定",
    recommendenTitle: "您有可能获得",
  },
  boxDetail: {
    joinRoomSucc: "加入等候室成功！",
    uMost: "您最多可",
    timeOut: "超时，请重新排队",
    waive: "放弃",
    continue: "继续",
    isWaive: "是否放弃",
    isWaive2: "？放弃后需要重新排队。",
    now: "立即",
    selectCount: "选择数量",
    moreBuy: "剩余最多",
    count: "数量",
    a: "个",
    //盲盒详情页面
    yy: "已有",
    rcyhd: "人参与活动",
    lj: "立即",
    lq: "领取",
    gm: "购买",
    qmhy: "前面还有",
    rzzpdgm: "人正在排队购买",
    y: "已",
    lw: "领完",
    sq: "售罄",
    kq: "开启",
    qs: "起售",
    isshowlastcount: "剩余",
    isshowtotalcount: "总数",
    money: "￥",
    waitingRoomCount: "已有人参与活动",
    showQueueModel: "查看队列详情",
    timerExpireVal: "立即购买",
    timeInterval2: "距加入等候室",
    timeInterval: "距活动开始",
    sort: "前面还有人正在排队购买",
    joinWaitingRoom: "加入等候室",
    NumberFenpei: "号码分配中",
    realTimeTitle: "活动时间",
    beijingStartwaittime: "等候室开放",
    beijingStartTime: "盲盒开售",
    beijingStartTime1: "盲盒领取",
    realTimeTitle2: "盲盒详情",
    detailTipsTitle: "数字资产小贴士",
    tipsCon: "在区块链技术的支持下，绘画、视频、模型、门票等任何种类的数字商品都可以被确权，即拥有了一张专属自己的“数字身份证”，这个独一无二的数据内容会永久的保存在区块链上，让数字商品可以被拥有并承载其独特的价值。",
    tipsCon1: "薄盒数字资产是基于「树图区块链」技术协议的数字商品，每个数字资产在「树图区块链」上都拥有唯一的标识，永久存储并且同样拥有不可篡改、不可分割的特性。「树图区块链」为数字资产的收藏提供区块链底层技术支持，为平台提供可信存证扩展、数字商品确权技术。",
    tipsCon1Text: "注意事项",
    tipsCon1Text2: "*请先完成实名认证，再进行购买",
    tipsCon1Text3: "*因为数字资产的特殊性，不能篡改，一旦销售不支持退换",
    recommendenTitle: "您有可能获得",
    modal: "订单尚未支付，是否继续支付？",
    modalOkText: "取消订单",
    modalCancelText: "继续支付",
    notStardTitleIsFree1: "活动开始，您已加入领取队列",
    notStardTitleIsFree0: "活动开始，您已加入购买队列",
    rzzpd: "人正在排队",
    BuyersText: "昵称",
    priceText: "队列号",
    codeText: "状态",
    hy: "还有",
    wyhzpdz: "位用户在排队中···",
    pendingInfo1: "*注：当其他⽤户领取盲盒时，有",
    pendingInfo2: "秒",
    pendingInfo3: "领取时间，在此期间内您的队列排名不会发⽣变化，当其他⽤户领取结束后队列排名会进⾏刷新。",
    pendingInfo4: "*注：当其他⽤户进行购买时，有",
    pendingInfo5: "下单时间，在此期间内您的队列排名不会发⽣变化，当其他⽤户购买结束后队列排名会进⾏刷新。",
    Leave1: "离开队列",
    Leave2: "离开后您将失去",
    Leave3: "机会",
    qr: "确认",
    qx: "取消",
    waitingTipsPo1: "活动开始前，请提前加入等候室等待。",
    waitingTipsPo2: "活动开始时，我们会优先为已经在等候室内的所有在线用户随机分配号码，按号码顺序进入完成",
    waitingTipsPo3: "如果在活动开始后加入等候室，则会按照现有最大排队号码 +1。",
    purchaseInstructions1: "须知",
    purchaseInstructions2: "请您务必审慎阅读 充分理解以下内容",
    purchaseInstructions3: "数字资产为虚拟数字商品，而非实物，仅限经实名认证为年满18周岁的用户",
    purchaseInstructions4: "本商品一经",
    purchaseInstructions5: "，不支持退换。",
    purchaseInstructions6: "数字资产的版权由发行方或创作家拥有，除另行取得版权拥有者书面同意外，用户不得将数字资产用于任何商业用途。",
    purchaseInstructions7: "数字资产暂不支持交易。",
    purchaseInstructions8: "本数字资产不得用于炒作、场外交易。如发现存在炒作等异常行为、涉嫌违法违规或协议禁止的行为，我们有权采取必要的限制措施；包含但不限于冻结账号等。",
    purchaseInstructions9: "请远离数字资产非理性炒作，防范欺诈风险。",
    jj: "拒绝",
    ty: "同意",
    xhtcp1: "销毁说明",
    xhtcp2: "本次在2个月内未销售完的数字资产将会自动销毁。以保证已发售的数字资产均是被用户所认可的。",
    xhtcp3: "知道了",
    leaveModalContent: "离开后您将失去购买机会，您确认离开队列吗？",
    leaveModalContent2: "离开后您将失去领取机会，您确认离开队列吗？",
    slbnwk: "请选择购买个数",
    mhyxj: "盲盒已下架",
    pendingListStatus: {
      1: "排队中",
      2: "购买中",
      3: "支付中",
    },
    pendingListStatus2: {
      1: "排队中",
      2: "领取中",
      3: "领取中",
    },
  },
  boxList: {
    //盲盒列表页面
    status4FalseType1: "出售中",
    status4FalseType2: "进行中",
    status4FalseType3: "领取中",
    status4TrueType1: "已售罄",
    status4TrueType2: "已结束",
    status4TrueType3: "已领完",
    loadText: "没有找到相关数据",
    loadText2: "暂无更多数据",
    newBox: "新盒推荐.",
    all: "全部",
    ing: "进行中",
    end: "已售罄",
  },
  certificateFreeBox: {
    //特殊盲盒页面
    surplus: "个",
    isshowlastcount: "剩余",
    isshowtotalcount: "总数",
    limitbuycount: "可领取盲盒数量：",
    getBox: "领取盲盒",
    timeInterval: "距活动开始",
    ylw: "已领完",
    hdsj: "活动时间",
    dhskf: "等候室开放：",
    kq: "开启",
    mhlq: "盲盒领取：",
    lq: "领取",
    kf: "开放",
    mhxq: "盲盒详情",
    szscpxts: "数字资产小贴士",
    tipsCon: "在区块链技术的支持下，绘画、视频、模型、门票等任何种类的数字商品都可以被确权，即拥有了一张专属自己的“数字身份证”，这个独一无二的数据内容会永久的保存在区块链上，让数字商品可以被拥有并承载其独特的价值。",
    tipsCon1: "薄盒数字资产是基于「树图区块链」技术协议的数字商品，每个数字资产在「树图区块链」上都拥有唯一的标识，永久存储并且同样拥有不可篡改、不可分割的特性。「树图区块链」为数字资产的收藏提供区块链底层技术支持，为平台提供可信存证扩展、数字商品确权技术。",
    tipsCon1Text: "注意事项",
    tipsCon1Text2: "*请先完成实名认证，再进行购买",
    tipsCon1Text3: "*因为数字资产的特殊性，不能篡改，一旦销售不支持退换",
    recommendenTitle: "您有可能获得",
    lqxzp1: "领取须知",
    lqxzp2: "请您务必审慎阅读 充分理解以下内容",
    lqxzp3: "数字资产为虚拟数字商品，而非实物，仅限经实名认证为年满18周岁的用户领取。",
    lqxzp4: "本商品一经领取，不支持退换。",
    lqxzp5: "数字资产的版权由发行方或创作家拥有，除另行取得版权拥有者书面同意外，用户不得将数字资产用于任何商业用途。",
    lqxzp6: "数字资产暂不支持交易。",
    lqxzp7: "本数字资产不得用于炒作、场外交易。如发现存在炒作等异常行为、涉嫌违法违规或协议禁止的行为，我们有权采取必要的限制措施；包含但不限于冻结账号等。",
    lqxzp8: "请远离数字资产非理性炒作，防范欺诈风险。",
    refuseBtn: "拒绝",
    agreeBtn1: "同意",
    xhtcp1: "销毁说明",
    xhtcp2: "本次在2个月内未销售完的数字资产将会自动销毁。以保证已发售的数字资产均是被用户所认可的。",
    xhtcp3: "知道了",
    nzdklq: "您最多可领取",
    fen: "个",
    slbnwk: "请选择购买个数",
    nzwlqzg: "暂无领取资格",


  },
  creatorDetail: {
    //创作家详情页面
    loadText: "没有找到相关数据",
    loadText2: "暂无更多数据",
  },
  creatorList: {
    //创作家列表页面
    loadText: "没有找到相关数据",
    loadText2: "暂无更多数据",
  },
  freeSuccess: {
    //领取盲盒成功页面
    successDesc: "领取成功",
    lookDetail: "查看",
    contentText: "秒后跳转至盲盒开启页面"
  },

  getBoxSuper: {
    //超能一家人打开盲盒页面
    laterOpen: "前往个人中心",
    Dropnum1: "盲盒掉落",
    Dropnum2: "个藏品",
    laterOpen2: "稍后打开",
    openBoxBtn: "打开盲盒",
    imgLabelimg: "保存图片"
  },
  getGift: {
    //领取藏品页面
    goShow3DPage: "3D空间",
    giveMessageInfo1: "赠送人",
    leaveMessageDiv: "好友给您的留言",
    nowReceive: "立即领取",
    isFiled: "领取失败",
    okText: "关闭",
    cancelText: "回首页",
  },
  giftLogin: {
    //领取藏品登录页面
    loginText: "请输入您的手机号",
    loginText2: "登录或注册您的薄盒账号",
    placeholder1: "请输入手机号",
    getCode: "获取验证码",
    yzm: "验证码",
    placeholder2: "请输入6位短信验证码",
    login: "登录",
    changeCheck: "未注册手机验证通过后自动登录，注册即表示同意",
    agreement: "《薄盒用户协议》",
    and: "和",
    conceal: "《隐私政策》",
    noCheckText: "请阅读并勾选页面协议",
    isSHowBtn: "我已阅读并同意",
    sendMessage: "发送成功",
    telText: "请填写手机号",
    yzmText: "请填写验证码",
  },
  giveGift: {
    //赠送藏品页面
    phoneText: "获赠人",
    MNSPlaceholder: "请输入获赠人MNS/地址",
    telPlaceholder: "请输入获赠人的手机号",
    leaveMessageDiv: "留言",
    msgPlaceholder: "请输入您给获赠人的留言（非必填）",
    reminderTips1: "温馨提示：",
    reminderTips2: "1、请认真核对受赠人的手机号信息，如填写错误对方将无法领取。",
    reminderTips22: "2、该数字资产在受赠满",
    reminderTips23: "天后，可再次发起赠送。",
    confirmBrn: "取消",
    sureGive: "赠送",
    okText: "否",
    cancelText: "是",
    isRegister1: "该用户未在平台注册！请告知好友使用",
    isRegister2: "的手机号领取",
    copySuccess: "复制成功,快去粘贴给你的好友吧！",
    navName1: "MNS/地址",
    navName2: "手机号",
    text1: "（非必填）",
    text2: "2、本数字资产受赠后即可赠送。",
    text3: "确认赠送",
    text4: "输入操作密码",
    text5: "忘记密码？使用",
    text6: "短信验证",
    text7: "该手机号尚未注册薄盒，若你确认赠送，我们将通过短信通知对方接收",
    text8: "该数字资产是否确认赠送给用户",
    text9: "请输入正确的手机号格式",
    text10: "请输入MNS/地址",
    text11: "请输入手机号",
  },
  giveSuccess: {
    //赠送藏品成功页面
    successText: "赠送成功",
    timeText: "秒后跳转藏品详情页面"
  },
  index: {
    //首页面
    giftsCon: "收到来自",
    toMY: "点击查看",
    Newboxrec: "新盒推荐",
    lookMore: "查看更多",
    digital: "数字证书",
    creator: "创作家",
    internet: {
      title: "温馨提示",
      text1: "1. 数字资产为虚拟数字商品，而非实物，仅限经实名认证为年满18周岁的用户购买。 ",
      text2: "2. 本商品一经出售，不支持退换。  ",
      text3: "3. 数字资产暂不支持交易。",
      text4: "4. 数字资产不得用于炒作、场外交易。如发现存在炒作等异常行为、涉嫌违法违规或协议禁止的行为，我们有权采取必要的限制措施；包含但不限于冻结账号等。",
      text5: "5. 合理评估风险识别能力和风险承担能力，理性参与数字资产，请远离数字资产非理性炒作，防范欺诈风险。",
      btn: "知道了",
    },
    jayModel: {
      title: "#杰伦元宇宙演唱会#",
      title2: "提示",
      num: "人",
      text: "想看薄盒与杰伦共同举办元宇宙演唱会，请进入音乐空间进行“点赞”。当点赞达到18:00时，我们将打开新的大门。",
      text2: "请下载APP前往音乐空间点赞并体验",
      btn: "去点赞",
      btn2: "去下载",
    }
  },
  login: {
    //登录页面
    title: "登录注册",
    tel: "手机号",
    telPlaceholder: "请输入手机号",
    getCode: "获取验证码",
    yzmtitle: "验证码",
    yzmPlaceholder: "请输入6位短信验证码",
    getCode: "获取验证码",
    login: "登录",
    changeCheck: "未注册手机验证通过后自动登录，注册即表示同意",
    agreement: "《薄盒用户协议》",
    and: "和",
    conceal: "《隐私政策》",
    noCheckText: "请阅读并勾选页面协议",
    isSHowBtn: "我已阅读并同意",
    sendSuccess: "发送成功",
    placeTel: "请填写手机号",
    placeYzm: "请填写验证码"
  },
  lotterCode: {
    //抽签码盲盒页面
  },
  openBox: {
    //打开盲盒后藏品展示页面
    showText: "查看全部藏品"
  },
  openBoxSuper: {
    //超能一家人打开盲盒后藏品展示页面
    laterOpen1: "前往个人中心",
    downloadBase64Img: "保存图片",
    downloadBase64Text: "长按保存图片",
  },
  openMyBox: {
    openBoxBtn: "返回个人主页",
    creatorName: "创作家",
    tags: "类型",
    opusopusseriesName: "系列",
    timer: "时长",
    adownload: "微信不支持下载，请点击右上角使用其它浏览器打开！",

  },
  page3D: {
    //3d展示页面
  },
  payment: {
    //支付页面
    dropNum1: "盲盒最多可能掉落",
    dropNum2: "个藏品",
    customerInfo1: "收货人",
    customerInfo2: "支付金额",
    apliyCheckFn: "支付宝支付",
    bankCheckFn: "银行卡快捷支付",
    surePayBtnFn: "确认支付",
    modal: "订单尚未支付，是否继续支付？",
    okText: "继续支付",
    cancelText: "取消订单",
    payResultModal: "您是否已完成本次支付？",
    okText2: "未支付",
    cancelText2: "我已支付",
    payResultSuccess: "支付中，请耐心等待！",
    payErrorText1: "订单已超时，请重新下单",
    payErrorText2: "交易失败",
  },
  paymentSuccess: {
    //支付成功页面
    successDesc: "支付成功",
    mnsSuccess: "查看",
    orderInfo1: "订单编号:",
    orderInfo2: "商品名称:",
    orderInfo3: "实付金额",
    orderInfo4: "银行卡优惠:",
    toIndex: "返回首页",
    lookDetail: "查看",
    contentText1: "秒后打开盲盒",
    contentText2: "秒后返回",
    contentText3: "秒查看藏品",
  },
  payMiddle: {
    //支付结果跳转页面
    payStatus1: "支付成功",
    payStatus2: "返回 薄盒",
    payStatus21: "查看MNS",
    payStatus22: "开启盲盒",
    payStatus3: "支付失败",
    payStatus4: "返回 薄盒 重新支付",
  },
  receive: {
    //证书页面
    creatorName: "创作家：",
    confluxaddress: "合约地址：",
    confluxname: "区块链：",
    ownername: "持有者：",
    nftid: "藏品ID：",
    have: "已拥有该系列藏品",
    lookInfo: "查看详情",
    noHave: "您暂未拥有该系列藏品",
    goService: "咨询客服",
    receiveAlertTit: "温馨提示",
    receiveAlertText: "该账号下未查询到相关数字证书，",
    receiveAlertText2: "请稍后再试！",
    receiveAlertConfirm: "确认",
    purchaseInstructionsTit: "数字证书说明",
    purchaseInstructionsText1: "立足于通过数字证书进行商品防伪溯源，保护正版价值。",
    purchaseInstructionsText2: "数字证书不具备交易价值，仅为确权工具，不允许炒作。",
    purchaseInstructionsText3: "本数字证书不得用于炒作、场外交易和任何商业用途。如发现存在炒作等异常行为、涉嫌违法违规或协议禁止的行为，我们有权采取必要的限制措施，包含但不限于冻结账号等。",
    purchaseInstructionsText4: "本数字证书可支持赠送，赠送程序需依据国家法律法规和政策不定期调整。",
    purchaseInstructionsText5: "请远离非理性炒作，防范欺诈风险。",
    refuseBtn: "取消",
    agreeBtn: "领取",
    purchaseInstructions2Tit: "领取须知",
    purchaseInstructions2Text1: "请您务必审慎阅读 充分理解以下内容",
    purchaseInstructions2Text2: "数字资产为虚拟数字商品，而非实物，仅限经实名认证为年满18周岁的用户领取。",
    purchaseInstructions2Text3: "本商品一经领取，不支持退换。",
    purchaseInstructions2Text4: "数字资产的版权由发行方或创作家拥有，除另行取得版权拥有者书面同意外，用户不得将数字资产用于任何商业用途。",
    purchaseInstructions2Text5: "数字资产暂不支持交易。",
    purchaseInstructions2Text6: "本数字资产不得用于炒作、场外交易和任何商业用途。如发现存在炒作等异常行为、涉嫌违法违规或协议禁止的行为，我们有权采取必要的限制措施；包含但不限于冻结账号等。",
    purchaseInstructions2Text7: "请远离数字资产非理性炒作，防范欺诈风险。",

  },
  sellingTime: {
    //藏品详情页面
    opusattrcustomerName: "拥有者",
    customersellerName: "赠送人",
    saleWorkModal: "出售",
    undercarriage: "下架",
    giveGift: "赠送",
    givingGift: "赠送中",
    // modal
    okText: "继续支付",
    cancelText: "取消订单",
  },
  setUp: {
    //setUp页面
    xmrz: "实名认证",
    wrz: "未认证",
    yrz: "已认证",
    dhm: "兑换码",
    yhkgl: "银行卡管理",
    jfye: "积分/余额",
    operatingPass: "操作密码"
  },
  VerificationInformation: {
    //区块链查证信息页面
  },
  wallet: {
    //钱包页面
  },
  workDetail: {
    //workDetail页面
  },
  //添加银行卡
  addBank: {
    addBankText1: "绑定银行卡",
    addBankText: "确认绑定银行卡",
    cardNum: "卡号",
    careNumPlcae: "银行卡号",
    caredName: "姓名",
    cardNamePlace: "开卡姓名",
    IDName: "身份证号",
    IDNamePlace: "银行预留身份证号",
    phone: "手机号",
    phonePlcae: "银行预留手机号",
    code: "验证码",
    codePlcae: "短信验证码",
    getCode: "获取验证码",
    openPay: "确认开户",
    agree: "接受",
    payAgreement: "《薄盒支付服务协议》",
    IncardNum: "请输入银行卡号",
    InCardName: "请输入开卡姓名",
    InCardIdNum: "请输入银行预留身份证号",
    InCardPhone: "请输入银行预留手机号",
    sendSuccess: "发送成功",
    pleaseReadAggrement: "请阅读并勾选银联用户相关服务协议",

  },
  //银行卡列表
  bankList: {
    bankCardPay: "银行卡付款",
    payName: "商户名称 北京擘盒科技有限公司",
    please: "请在",
    complatedPay: "内完成支付",
    chooseBank: "选择银行卡",
    addBank: "添加银行卡",
    goPay: "确认支付",
    setPwd: "请先设置支付密码",
    confirm: "取消",
    goSet: "去设置",
    isComplatePay: "您是否已完成本次支付？",
    noPay: "未支付",
    isPay: "我已支付",
    payStatus: "支付中，请耐心等待！",
    bankUpper: "银行卡数量已达上限",
    orderTimeOut: "订单已超时，请重新下单",
    payError: "交易失败",
  },
  //银行卡管理
  bankManage: {
    bankManage: "银行卡管理",
    noBank: "暂无可用银行卡",
    removeBind: "解除绑定",
    isRemoveBind: "是否解除绑定",
    removeTips: "解除绑定后，将无法使用该银行卡在平台进行支付",
    Sure: "确定",
    confirm: "取消",
    operationSuccess: "操作成功",
    bankNumUpper: "银行卡数量已达上限"
  },
  //免费邀请盲盒
  freeBox: {
    activityStart: "距活动开始时间",
    activityEnd: "距活动结束时间",
    leadBoxNum: "您当前可领的盲盒数：",
    InvitePerson: "邀请新用户注册，可获取更多盲盒",
    goInvite: "去邀请",
    nowReceive: "立即领取",
    isgone: "已领完",
    activityTime: "活动时间",
    activityTimeDes: "活动开启：",
    activityTimeDesSpan: "开启",
    activityTimeDes1: "活动结束：",
    activityTimeDes1Span: "结束",
    boxDetailText: "盲盒详情",
    receivingInstructions: "领取须知",
    receivingInstructionsDes1: "请您务必审慎阅读 充分理解以下内容",
    receivingInstructionsDes2: "数字资产为虚拟数字商品，而非实物，仅限经实名认证为年满18周岁的用户领取。",
    receivingInstructionsDes3: "本商品一经领取，不支持退换。",
    receivingInstructionsDes4: " 数字资产的版权由发行方或创作家拥有，除另行取得版权拥有者书面同意外，用户不得将数字资产用于任何商业用途。",
    receivingInstructionsDes5: "数字资产暂不支持交易。",
    receivingInstructionsDes6: "本数字资产不得用于炒作、场外交易。如发现存在炒作等异常行为、涉嫌违法违规或协议禁止的行为，我们有权采取必要的限制措施；包含但不限于冻结账号等。",
    receivingInstructionsDes7: "请远离数字资产非理性炒作，防范欺诈风险。",
    receivingInstructionsDes8: "拒绝",
    receivingInstructionsDes9: "同意",
    destoryDesTitle: "销毁说明",
    destoryDes1: "本次在2个月内未销售完的数字资产将会自动销毁。以保证已发售的数字资产均是被用户所认可的。",
    destoryDes2: "知道了",
    InviteDesCon: "邀请好友注册领取更多盲盒",
    InviteDesCo1: "每邀请1个好友注册，即可额外领取1个盲盒",
    nowInvite: "立即邀请",
    maxInvite: "您最多可领取",
    maxInvite1: "个",
    setTimeText: "天:时:分:秒",
    boxOff: "盲盒已下架",
  },
  //kyc认证
  kyc: {
    btnText1: "开始认证",
    btnText2: "稍后再去",
    authenticationError: "身份认证失败！",
    authenticationNum: "今日剩余认证次数：",
    frequency: "次",
    reUpload: "重新上传",
    return: "返回",
    authenticationSuccess: "身份认证通过！",
    complete: "完成",
    LV1Text: "Lv1身份认证",
    LV1TextText: "通过Lv1身份认证  即可参与盲盒活动",
    LV1Text1: "人脸识别",
    LV1Des1: "创建你的数字身份",
    LV1Des2: "数字身份基于区块链地址，按照法律法规要求，需要用户提供身份信息，请填写真实、有效的信息。",
    LV1Des3: "实名认证后即可自动创建区块链地址，请确认注册手机号与实名信息匹配。",
    reallyName: "真实姓名",
    namePlace: "请输入您的真实姓名",
    getCode: "获取验证码",
    Next: "下一步",
    cardType: "证件类型",
    cerdNum: "证件号码",
    cerdNumPlace: "请输入您的证件号码",
    IKnow: "我已阅读并同意",
    userAgreement: "《用户协议》",
    and: "和",
    privacyPolicy: "《隐私政策》",
    pleaseSure: "请确保为",
    myOperation: "本人操作",
    operationDes1: "请在明亮光线环境下录制",
    operationDes2: "请在录制过程中眨眼3-5次",
    operationDes3: "录制时长3-5秒",
    operationDes4: "开始录制视频",
    operationDes5: "检测中，请耐心等待",
    operationDes6: "视频长度和手机的网络速度会影响检测时间",
    operationDes7: "确认",
    operationDes8: "请阅读并勾选页面协议",
    passedLV1: "该账号已通过Lv1身份认证",
    confirm: "确认",
    choose: "请选择",
    cardError: "身份证信息填写有误",
    IDcard: "身份证",
    passIdCard: "港澳台通行证",
    passIdCard1: "外国人永久居留身份证",
    passIdCard2: "定居国外的中国公民护照"
  },
  //域名购买
  mns: {
    buyMns: "购买MNS",
    curNoMns: "当前暂无可用MNS",
    whatMns: "什么是MNS",
    nowUseMns: "当前使用的MNS",
    noMnsText: "当前暂无可用域名，快去购买吧～",
    noText: "暂无数据",
    isChangeNowUseMns: "是否切换当前使用的MNS？",
    Sure: "确认",
    Confirm: "取消",
    Obtained: "已获得",
    UnderReview: "审核中",
    PurchaseFailed: "购买失败",
    changeSuccess: "切换成功！",
    mnsBuy: "MNS购买",
    payMoney: "应付金额：",
    apliyPay: "支付宝支付",
    bankPay: "银行卡支付",
    surePay: "确认支付",
    isContinuePay: "订单尚未支付，是否继续支付？",
    continuePay: "继续支付",
    concelOrder: "取消订单",
    isComplatePay: "您是否已完成本次支付？",
    noPay: "未支付",
    hasPay: "我已支付",
    transactionFailure: "交易失败",
    payWait: "支付中，请耐心等待！",
    payError: "交易失败",
    orderTimeOut: "订单已超时，请重新下单",
  },
  //支付
  pay: {
    consignee: "收货人",
    payMoney: "支付金额",
    apliyPay: "支付宝支付",
    weichatPay: "微信支付",
  },
  myCenter: {
    zdl: "知道了",
    kfMail: "邮箱：info@mints.cn",
    kf: "联系客服",
    followList: "关注列表",
    beConcerned: "被关注",
    Concerned: "关注",
    all: "全部",
    noCareText: "暂无被关注",
    collectionsNum: "藏品数量：",
    care: "关注",
    hasCare: "已关注",
    crossCorrelation: "互关",
    Huiguan: "回关",
    noCareText1: "暂无关注",
    isSureConfim: "是否确认取消关注",
    yes: "是",
    no: "否",
    closeSuccess: "取关成功！",
    careSuccess: "关注成功！",
    Collection: "藏品",
    Blindbox: "盲盒",
    filter: "筛选",
    noBoxText: "暂无相关盲盒",
    drop: "掉落",
    individual: "个藏品",
    noBoxText1: "暂无相关藏品",
    serialnumber: "藏品序号",
    label: "标签",
    putaway: "收起",
    open: "展开",
    reset: "重置",
    sure: "确定",
    filteredForYou: "已为您筛选出",
    Articleresults: "条结果",
    myMns: "我的MNS",
    whatMns: "什么是MNS",
    mnsDes1: "MNS是Mints Name Service缩写，它是一个基于树图区块链的可扩展和开放式化的命名系统，主要服务于用户可读区块链地址映射名称，旨在为用户提供简短易读的名称，可通过购买获得。",
    mnsDes2: " MNS是你的“元宇宙”起点，是属于每个人的数字身份名片，它会连接你在数字世界中的成就、贡献、兴趣和活动，一旦拥有它，它就会和你的区块链地址绑定，成为你数字资产的一部分。",
    mnsDes3: " 1、获得MNS之后可以绑定自己的区块链地址。",
    mnsDes4: "2、用户需先完成实名认证，再进行购买。每个用户都可以通过搜索栏检索寻找想要购买的MNS，如此前未有人注册过，您即可发起购买，支付完成后进入审核阶段。",
    mnsDes5: "3、MNS可以是26个英文字母及10个阿拉伯数字任意顺序组成，现阶段可购买至少要用7个字符组成，并会自动在组合文字后面添加“.mints”的后缀，如“ab12.mints”。",
    mnsDes6: " 4、所有MNS购买前都需要完成审核，您设置的名称不得侵犯或涉嫌侵犯他人的合法权益。设置名称时遵守以下规定：",
    mnsDes7: "（1）名称及其读音、音译、翻译不得与党和国家领导人或其他社会名人的真实姓名、字号、艺名、笔名相同；",
    mnsDes8: "（2）名称及其读音、音译、翻译不得与国家机构或其他机构的名称相同；",
    mnsDes9: "（3）名称及其读音、音译、翻译不得包含歧视、侮辱、猥亵类词语；",
    mnsDes10: "（4）名称及其读音、音译、翻译不得侵害有关驰名商标的权利；",
    mnsDes11: "（5）不设置易产生歧义、引起他人误解的账号的名称；",
    mnsDes12: "（6）不得危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一；",
    mnsDes13: "（7）不得损害国家荣誉和利益的，损害公共利益；",
    mnsDes14: "（8）不得煽动民族仇恨、民族歧视，破坏民族团结；",
    mnsDes15: "（9）不得破坏国家宗教政策，宣扬邪教和封建迷信；",
    mnsDes16: "（10）不得散布谣言，扰乱社会秩序，破坏社会稳定；",
    mnsDes17: "（11）不得散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪；",
    mnsDes18: "（12）不得侮辱或者诽谤他人，侵害他人合法权益；",
    mnsDes19: "（13）不得违反宪法或法律法规规定；",
    mnsDes20: "（14）不得含有法律、行政法规禁止的其他内容。",
    mnsDes21: "如您设置的名称涉嫌侵犯他人合法权益或者含有法律、行政法规等规范性文件、监管政策等禁止的内容，我们有权拒绝通过。",
    mnsDes22: "5、名称通过审核后，用户即可拥有此MNS的使用权。",
    mnsDes23: "6、你的好友可以通过名称搜索关注你以及访问你的空间。",
    mnsDes24: "7、若您已购买的MNS中包含涉嫌侵犯他人合法权益或者含有法律、行政法规等规范性文件、监管政策等禁止的词汇或者该等词汇的读音、音译、翻译的，薄盒有权收回您已购买的MNS，在收回后您无权使用该MNS。我们对此不承担任何责任，您将承担因此产生的任何直接或间接损失及不利后果。",
    mnsDes25: "8、您理解并确认，因MNS不能篡改的特殊性，MNS一旦售出，不支持退换。",
    mnsDes26: "您理解并确认，薄盒有权根据国家法律法规、监管政策的变化或风险防范的需要对MNS的相关服务作出调整或更新，我们会以公告等通知方式就与MNS相关服务的更新向您进行提示。除通知中另有说明外，更新的内容将于更新公告公布的生效之日起生效。若您不接受变更后的服务内容或功能，或不同意更新后的相关协议内容，您需立即停止使用相关服务。若您继续使用薄盒提供的相关MNS服务的，即视为您已同意我们作出的变更，并自愿接受变更后的协议内容约束。",
    mnsDes27: "购买MNS",
    nameCreater: "盲盒名称/创作家",
    nameCode: "藏品名称/创作家/系列/编号",
    confirm: "取消",
    noFound: "没有搜索到相关",
    tryAnother: "换个搜索内容试试",
    InContent: "请输入搜索内容",
    address: "地址:",
    Digitalcollection: "数字资产",
    message: "消息",
    Digitalspace: "数字空间",
    More: "更多",
    careofficialAccount: "* 关注「薄盒」公众号",
    downApp: "下载APP可享更多福利",
    copySuccess: "复制成功",
    loginSuccessLook: "登陆后可查看相关内容",
    mnsName: "MNS名称/地址",
    allHistory: "全部搜索记录",
    delHistory: "清除搜索记录",
    isDelHistory: "历史记录清除后无法恢复，是否清除全部记录",
    del: "清除",
    noSearchText: "暂无搜索数据",
    noRegister: "未注册",
    buy: "购买",
    goPayText: "订单尚未支付，是否继续支付？",
    modalOkText: "取消订单",
    modalCancelText: "继续支付",
    orderConfirmSuccess: "订单取消成功！",
    Domainoccupied: "域名被占用",
    confirm: "取消",
    cover: "封面",
    inuse: "使用中",
    Savereplacement: "保存更换",
    replacementSuccess: "更换成功！",
    careAccount: "关注官方公众号【薄盒】，最新资讯尽在掌握",
  },
  //超级一家人
  superFamily: {
    des1: "票房达到要求后，次日12点开启数字超能力盲盒领取等候室，",
    des2: "13点正式开放领取",
    des3: "共10000个盲盒，领完为止",
    des4: "2021.1.30",
    des5: "获得主题数字空间盲盒",
    des6: "前往个人中心",
    savePicture: "保存图片",
    Longpresspicture: "长按保存图片",
    copySuccessToFriend: "复制成功,快去粘贴给你的好友吧！"
  },
  wxLogin: {
    loginRegister: "登录注册",
    phone: "手机号",
    phonePlcae: "请输入手机号",
    code: "验证码",
    codePlcae: "请输入6位短信验证码",
    getCode: "获取验证码",
    InvitationCode: "邀请码",
    InvitationCodePlace: "必填，请输入好友的邀请码",
    login: "登录",
    loginTip: " 未注册手机验证通过后自动登录，注册即表示同意",
    arrgement: "《薄盒用户协议》",
    and: "和",
    Privacypolicy: "《隐私政策》",
    loginTip1: "请阅读并勾选页面协议",
    readagree: "我已阅读并同意",
    sendSuccess: "发送成功",
    fillPhone: "请填写手机号",
    fillCode: "请填写验证码",
    fillInvitationCode: "请填写邀请码",
    loginSuccess: "登录成功"
  },
  404: {
    noFind: "对不起，您访问的页面走丢了～",
    toIndex: "返回首页"
  },

  //兑换码
  activationcode: {
    activationcode: "兑换码",
    activationcodeDes: "请输入16位兑换码进行兑换",
    activationcodePlace: "请输入兑换码",
    Redeemnow: "立即兑换",
    customerservice: "咨询客服",
    rules: "兑换码规则",
    rulesDes1: "1、请先完成实名认证，仅支持年满18周岁的用户。",
    rulesDes2: "2、输入正确的兑换码后，可获得对应数字资产。",
    rulesDes3: "3、一个兑换码仅限兑换一次，不可重复使用。",
    exchangeSuccess: "恭喜您兑换成功！",
    ViewCertificate: "查看藏品",
    digitalDes: "数字证书说明",
    digitalDes1: "请您务必审慎阅读 充分理解以下内容",
    digitalDes2: "立足于通过数字证书进行商品防伪溯源，保护正版价值。",
    digitalDes3: "数字证书不具备交易价值，仅为确权工具，不允许炒作。",
    digitalDes4: " 本数字证书不得用于炒作、场外交易和任何商业用途。如发现存在炒作等异常行为、涉嫌违法违规或协议禁止的行为，我们有权采取必要的限制措施，包含但不限于冻结账号等。",
    digitalDes5: "请远离非理性炒作，防范欺诈风险。",
    digitalDes6: "本数字证书可支持赠送，赠送程序需依据国家法律法规和政策不定期调整。",
    digitalDes7: " 为了防止炒作，本数字证书需至少持有达到",
    digitalDes8: "天后可无偿赠送，赠送程序需依据国家法律法规和政策不定期调整。",
    confirm: "取消",
    exchange: "兑换",
  },
  //组件
  //盲盒详情
  boxIntro: {
    boxDetailText: "盲盒详情",
    detailTipsTitle: "数字资产小贴士",
    detailTipsDes1: "唯一编号",
    detailTipsDes2: "可信记录",
    detailTipsDes3: "永久存证",
    detailTipsDes4: "不可篡改",
    tipsCon: "在区块链技术的支持下，绘画、视频、模型、门票等任何种类的数字商品都可以被确权，即拥有了一张专属自己的“数字身份证”，这个独一无二的数据内容会永久的保存在区块链上，让数字商品可以被拥有并承载其独特的价值。",
    tipsCon1: "薄盒数字资产是基于「树图区块链」技术协议的数字商品，每个数字资产在「树图区块链」上都拥有唯一的标识，永久存储并且同样拥有不可篡改、不可分割的特性。「树图区块链」为数字资产的收藏提供区块链底层技术支持，为平台提供可信存证扩展、数字商品确权技术。",
    tipsCon1Text: "注意事项",
    tipsCon1Text2: "*请先完成实名认证，再进行购买",
    tipsCon1Text3: "*因为数字资产的特殊性，不能篡改，一旦销售不支持退换",
    recommendenTitle: "您有可能获得",
    tipsText1: "唯一编号",
    tipsText2: "可信记录",
    tipsText3: "永久存证",
    tipsText4: "不可篡改",
  },
  //官方授权·树图区块链技术支持·限量发行「
  officialAuthorization: {
    des1: "官方授权·树图区块链技术支持·限量发行",
    des2: "品牌保障",
    des3: "官方授权",
    des4: "数字资产由品牌方官方授权，在薄盒Mints平台独家发行，盗版必究。",
    des5: "树图区块链技术支持",
    des6: "薄盒Mints数字资产是基于「树图区块链」技术协议发行的数字商品，每个数字资产在「树图区块链」都有链上唯一标识，且不可复制、不可篡改、不可分割。「树图区块链」为数字资产的发行交易提供区块链底层技术支持，为薄盒Mints数字潮玩收藏平台提供可信存证技术、数字资产凭证技术服务。",
    des7: "限量发行",
    des8: "平台内所有数字资产均为限量、限时发售，每个发售的数字资产均有独一无二的所有权凭证，同时，平台将会致力于持续升级商品的消费和收藏体验。"
  },
  //banner
  banner: {
    bannerText1: "了解薄盒",
    bannerText2: "数字艺术的时代已经到来，让日常充满艺术收藏的趣味并且与睁眼所见的生活相融为一体，已不再是遥不可及的。伴随着数字艺术的潮流兴起，运用区块链不可逆、不可篡改的特性，薄盒与各领域的顶尖艺术创作者合作将每件藏品赋予独一无二的身份证码。在薄盒平台上，人人都有机会拥有官方认证的传奇数字艺术品。",
    bannerText3: "除了让艺术收藏成为零距离、无界限的新乐趣，薄盒也为创作者打造一个新时代的艺术交流平台。而数字艺术的崛起将重新定义艺术创作的价值与专属限定的珍藏感。加入薄盒，您也可以成为前卫艺术收藏家。",
    return: "返回",
    activityStart: "距活动开始时间",
    activityEnd: "距活动结束时间",
    openTime: "距等候室开放时间",
    days: "天",
    hours: "小时",
    minutes: "分钟",
    seconds: "秒",
  },
  //藏品详情
  collectionDetails: {
    des1: "官方授权·树图区块链技术支持·限量发行",
    info1: "技术信息",
    info2: "发行方",
    info3: "藏品ID",
    info4: "合约地址",
    info5: "区块链",
    info6: "树图区块链",
    info7: "藏品详情",
    info8: "版本序号",
    info9: "收藏中",
    info10: "待投放",
    info11: "已销毁",
    classfiy: "分类",
    series: "系列",
    slice: "片段",
    level: "等级",
    publishTime: "专辑发布",
    creator: "创作家",
    creatorBirthday: "创作家生日",
    creatorConstalltion: "创作家星座",
    purchaseInstructionsP1: "品牌保障",
    purchaseInstructionsP2: "官方授权",
    purchaseInstructionsP3: "数字资产由品牌方官方授权，在薄盒Mints平台独家发行，盗版必究。",
    purchaseInstructionsP4: "树图区块链技术支持",
    purchaseInstructionsP5: "薄盒Mints数字资产是基于「树图区块链」技术协议发行的数字商品，每个数字资产在「树图区块链」都有链上唯一标识，且不可复制、不可篡改、不可分割。「树图区块链」为数字资产的发行交易提供区块链底层技术支持，为薄盒Mints数字潮玩收藏平台提供可信存证技术、数字资产凭证技术服务。",
    purchaseInstructionsP6: "限量发行",
    purchaseInstructionsP7: "平台内所有数字资产均为限量、限时发售，每个发售的数字资产均有独一无二的所有权凭证，同时，平台将会致力于持续升级商品的消费和收藏体验。",
    copySuccess: "复制成功！"
  },
  //历史交易记录
  history: {
    history: "历史记录",
    buyer: "买家",
    price: "价格",
    code: "编号",
    timeText: "交易时间",
  },
  //推荐藏品
  recommend: {
    recommendWork: "推荐藏品",
    moneySymbol: "¥",
    rise: "起",
    saled: "个出售",
    noMsg: "暂无推荐藏品"
  },
  //confirm弹窗
  confirm: {
    tips: "提示"
  },
  //底部
  footer: {
    weixinCare: "微信关注",
    serviceNumber: "「薄盒」服务号",
    aboutUs: "关于我们",
    problems: "常见问题",
    concel: "隐私政策",
    agreement: "使用协议",
    Copyright: "Copyright © 2021 北京擘盒科技有限公司 京ICP备2021015762号",
    Copyright1: "京网信备11010521639830920018号"
  },
  //开盲盒
  // getBox: {
  //   boxDrop: "盲盒掉落",
  //   workNum: "个藏品",
  //   later: "稍后打开",
  //   open: "打开盲盒",
  //   saved: "盲盒已存入个人主页",
  //   returnMyCenter: "返回个人中心",
  //   goBack: "返回上一页"
  // },
  getBox: {
    //打开盲盒页面
    Dropnum1: "盲盒掉落",
    Dropnum2: "个藏品",
    laterOpen: "稍后打开",
    openBoxBtnAll: "批量打开",
    openBoxBtn: "打开盲盒",
    laterToastMessage: "盲盒已存入个人主页"
  },
  //头部
  header: {
    login: "登录",
    signOut: "退出",
    logOut: "退出登录",
    newBox: "新盒推荐",
    getMore: "了解更多",
    downApp: "下载App ",
    wallet: "钱包余额",
    myCenter: "个人主页",
    industry: "行业资讯",
    language: "多语言",
  },
  //kyc认证弹窗
  kycModal: {
    timesexhausted: "今日认证次数已用尽！",
    tomorrow: "明日再来",
  },
  //分享share
  share: {
    shareTo: "分享至",
    downFile: "下载文件",
    poster: "生成海报",
    copyLink: "复制链接",
    confirm: "取消",
    savePicture: "保存图片",
    longSave: "长按保存图片",
    copySuccess: "复制成功,快去粘贴给你的好友吧！",
    clickTopRight: "点击右上角选择好友分享",
    clickTopRight1: "点击右上角选择朋友圈分享",
    copySuccess: "复制成功",
    dontSuppot: "微信不支持下载，请点击右上角使用其它浏览器打开！",
    weiChat: "微信",
    WechatMoments: "朋友圈",
    sina: "新浪微博",
  },
  //抽签码规则
  detailedRules: {
    text1: "抽签码规则",
    text2: "一、参与对象",
    text3: "薄盒平台注册用户",
    text4: "二、活动规则",
    text5: " 1、用户在活动期间内进入抽签活动页面，在指定活动时间内完成登记，即可获得一个抽签码；在活动指定时间内将活动页面分享给其他用户并获得其助力，可获得更多抽签码。",
    text6: "2、发签结束后平台将在所有成功发放的抽签码中随机抽取一定数量的中签用户，并于该活动页面进行公示，领取到中签码的用户即可成功获得免费盲盒奖品。",
    text7: "3、同一用户最多可有4个抽签码有机会中签，若抽取到多个中签码属于同一用户，则领取盲盒时，可领取到多个盲盒。",
    text8: "4、为了保证活动公平，不同用户ID，但存在下列情况的：同一个设备号、同一个身份认证信息、同一个支付信息等能判定为同一人的均视为同一用户，同一用户下，最多可获得4个奖品。",
    text9: "5、奖单公示后，盲盒领取时间为3小时，超过领取时限后盲盒奖品将无法领取，视为用户主动放弃中奖资格，薄盒平台不提供任何形式的补偿。",
    text10: "三、特别说明",
    text11: "1、活动期间，为了保证活动公平，如发现用户存在违规行为（包括但不限于作弊、刷单/量、虚假交易、网络攻击、或者损害其他用户、薄盒平台及任何第三方合法权益的行为等），薄盒平台将有权撤销用户活动资格、取消全部抽签码及盲盒领取资格、暂定且限制薄盒平台服务（包括不限于薄盒平台上的其他形式的营销活动等）。若您已领了活动奖品，则平台有权收回您所获得的盲盒。用户因轻信第三方导致的损失，由用户自行负责。",
    text12: "2、由于互联网技术等客观因素，薄盒平台显示的信息可能存在一定的滞后性或差错，对此情景用户知悉并了解。因此，由于排版错误或信息错误导致活动以不正确或明显不合理的信息显示时，薄盒平台有权取消该不正确或明显不合理的盲盒订单。",
    text13: "3、如出现不可抗力或情势变更的情况（包括但不限于重大灾害事件、活动受政府机关指令需要停止举办或调整的、活动遭受严重网络攻击或因系统故障需要暂定举办的）导致活动内容发生变动（如活动规则变动、活动暂停或取消等），用户同意薄盒平台不因此承担任何责任。",
    text14: "4、薄盒平台有权随时变更本规则说明，变更内容一经公示即生效，若您对本规则有任何疑问，请登录至薄盒平台找线上客服咨询。"
  },
  // 消息中心
  myMessage: {
    message: "消息",
    allRead: "全部已读",
    view: "查看",
    sysMsg: "系统消息",
    sysAnnouncement: "系统公告",
    noMore: "没有更多消息了",
    noMsg: "暂无消息",
    isAllRead: "是否标记全部已读？"
  },
  // 操作密码
  operatePass: {
    text1: "输入当前操作密码",
    text2_1: "忘记密码？使用",
    text2_2: "短信验证",
    text3: "获取验证码",
    text3_1: "输入验证码",
    text4: "验证码已经发送到您的手机：",
    text5: "验证码",
    text6: "后可重新获取",
    text7: "下一步",
    text8: "设置成功",
    text9: "成功",
    text10: "操作密码用于藏品赠送等操作",
    text11: "输入新操作密码",
    text12: "操作密码",
    text13: "暂未设置操作密码",
    text14: "设置操作密码",
    text15: "验证码发送成功！",
    text16: "修改操作密码",
    text17: "修改新的操作密码",
    text18: "再次输入新操作密码",
    text19: "2次密码输入不一致！",
    text20: "密码设置成功！",
    text21: "密码修改成功！",
  },
  // 我的客服
  kfCode: {
    title: "我的客服",
    text1: "（长按保存二维码）",
    text2: "VIP客户服务二维码 微信扫码添加专属客服",
  },
  // 行业资讯
  industryInfo: {
    title: "行业资讯"
  },
  // 首页banner
  newBanner: {
    status1: "等候室开放 ",
    status2: "活动开始 ",
    status3: "活动进行中 ",
    status4: "活动已结束 ",
  },
  // 区块链查证信息
  cfxPage: {
    title: "区块链查证信息",
    opusname: "藏品名称",
    creatorname: "创作家",
    confluxaddr: "交易哈希",
    ing: "上链中...",
    blockhash: "区块哈希",
    paytime: "时间戳",
    sender: "发送方",
    receiver: "接收方",
    contractaddr: "合约地址",
    status: "状态",
    sussess: "成功",
    domain: "MNS名称",
    name: "POAP名称",
  },
  // 下载页面
  download: {
    text1: "薄盒致力于帮助用户构建自己的下一代可视化数字身份，基于区块链技术确权数字内容，提供可信存证技术、藏品数字凭证技术服务。",
    text2: "开发商：北京擘盒科技有限公司",
    text3: "版本号：",
    text4: "《隐私协议》",
    text5: "《薄盒用户协议》",
    text6: "点击右上角选择浏览器打开",
    text7: "如浏览器打开失败，请移步桌面直接打开应用",
  },
  //poapRule
  poapRule: {
    title: "什么是POAP？",
    text1: "POAP 数字成就徽章是一种可信记录生活经历的新方式，是基于区块链上的一种出席证明协议，也是一种通过创造数字纪念品来记录特定事件的协议。",
    text2: "每个 POAP 都是发行方送给收藏家的礼物，以庆祝特殊的共享记忆，证明自己亲身经历过这些“历史性”活动。",
    text3: "通过将这些记忆铸造到区块链中，这些记忆是不可替代、不可篡改的。",
    text4: "1、POAP是独特的数字资产。",
    text5: "2、平台会不定期创建活动，你可以通过参与相关活动事件获得POAP。",
    text6: "3、POAP通过智能合约自动触发发放。",
    text7: "4、你获得POAP后，不支持转移、售卖。",
    text8: "5、你可以在个人中心展示、查看、分享自己拥有的POAP。",
  },
  // 首页收到礼物
  indexGiftShow: {
    text1: "收到来自的",
    text2: "好友的礼物",
    btn1: "关闭",
    btn2: "去查看",
  },
  //盲盒赠送页面
  giftBox: {
    text1: "赠送须知",
    text2: "请您务必审慎阅读 充分理解以下内容",
    text3: "数字资产/证书不具备交易价值，仅为确权工具，请勿炒作。",
    text4: "立足于通过数字证书进行商品防伪溯源，保护正版价值。",
    text5: "如需线下赠予好友食物藏品，请同时将匹配的数字证书赠送给获赠人。",
    text6: "本数字资产不得用于炒作、场外交易和任何商业用途。如发现存在炒作等异常行为、涉嫌违法违规或协议禁止的行为，我们有权采取必要的限制措施；包含但不限于冻结账号等。",
    text7: "请远离数字资产非理性炒作，防范欺诈风险。",
    text8: "拒绝",
    text9: "同意",
    text10: "你还未设置密码，请前往设置",
    text11: "前往设置",
  },
  // actKeys\
  actKeys: {
    ruleModel: {
      title: "活动规则",
      text1: "活动时间：2022-08-29至2022-09-30，活动时间内通过分享活动，邀请尚未参加本活动的用户参加、注册、认证、购买盲盒等获得能量值（限量盲盒活动分享无效）。",
      text111: "本活动仅针对「精装盲盒」，「限量盲盒」不参与该活动",
      text2: "能量值奖励",
      text3: "1、分享专题活动，邀请1位用户参与本次活动，即可获得数字人人物周杰伦专属动作“哥觉得可以”。",
      text4: "2、分享邀请好友注册 +1能量/人",
      text5: "3、分享邀请好友完成实名认证，+2能量/人",
      text6: "5、分享邀请用户购买精装盲盒，+5能量/盲盒。",
      text7: "6、用户自己购买精装盲盒，+10能量/盲盒",
      text8: "7、邀请6位新用户付费购买，可获得一个精装盲盒，无上限。盲盒数量不在30个限制内。",
      text9: "每日能量值单独统计，能量值排名第一奖励",
      text10: "1、获得一把传奇钥匙。",
      text11: "2、获得周杰伦签名照一张。",
      text12: "3、获得【最伟大的作品】精装版实体专辑一张。",
      text13: "4、获得限量海报一张。",
      text14: "以系统判定当日首先到达最高分为准。以上所得奖励以官方发放安排为主。",
      text15: "本着公平公正的规则，维护正常参与用户的权益，如在活动中发现有人通过违规的方式进行刷单、刷榜等行为，我们将会第一时间取消该用户的活动参与资格。",
      text16: "4、邀请好友+好友认证每日上限800能量，如达到800能量后，再邀请好友完成注册或认证不再额外获得能量"
    },
    page: {
      createorName: "杰威尔音乐",
      actName: "周杰伦限定珍藏DEMO空间",
      goMscHome: "音乐空间",
      tickets: "开启周杰伦音乐元宇宙门票的数字钥匙",
      actTime: {
        title: "活动周期：",
        stime: "活动开始时间：2022.08.29 18:00",
        etime: "活动结束时间：9月30日",
      },
      rankInfo: {
        text1: "传奇钥匙33把、周杰伦签名照33张",
        text2: "【最伟大的作品】精装版实体专辑+限量海报33份",
        text3: "本活动仅针对「精装盲盒」,「限量盲盒」不参与该活动",
      },
      btmShare: "邀请好友，获得更多惊喜",
      news: {
        text1: "恭喜",
        text2: "用户获得",
        text22: "用户昨日获得",
        text3: "一把",
      },
      moreAward: {
        text1: "购买盲盒即可获得",
      },
      textInfo1: "“数字钥匙”作为唯一进入『 周杰伦限定珍藏DEMO空间 』凭证，“数字钥匙”分为经典、稀有、传奇三种等级，本次发售盲盒分精装盲盒、限量盲盒两款。『 周杰伦限定珍藏DEMO空间 』进入空间唯一凭证『 可收藏数字钥匙盲盒 』8月29日正式开售。",
      navName1: "活动详情",
      navName2: "排行榜",
      rankTabName1: "今日排名",
      rankTabName2: "今日能量值",
      rankTabName3: "累计能量值",
      rankTabName4: "邀请购买总人数",
      rankTableTh1: "排名",
      rankTableTh2: "用户",
      rankTableTh3: "今日获得能量值",
      actTitle1: "空间入场凭证",
      actTitle2: "盲盒活动",
      actTitle3: "排行榜",
      rewardInfoTitle1: "奖励",
      rewardInfoTitle2: "活动条件",
      sTit1: "殿堂级的音乐艺术结合前端数字音乐视听收藏技术开启周氏元宇宙第一站 ",
      // sTit2: "殿堂级的音乐艺术结合前端数字音乐视听收藏技术开启周氏元宇宙第一站",
      storyText: "杰威尔音乐与薄盒Mints跨界强强联手打造华语乐坛殿堂级音乐元宇宙『 周杰伦限定珍藏DEMO空间 』，音乐DEMO空间由5首精选DEMO组成，每首皆为周杰伦亲自挑选，其中包含4首在华人世界具超高传唱度且为经典代表的歌曲DEMO如《青花瓷》、《爱在西元前》、《晴天》、《搁浅》，<b>以及1首从未发表且完成度极高如新歌的隐藏DEMO曲目《纽约地铁》</b>。『 周杰伦限定珍藏DEMO空间 』除了是华语乐坛数字音乐收藏的极致视听盛宴，双方更致力于结合元宇宙视觉影像的前卫风格与设计概念，融合初始音乐DEMO与区块链技术拓展未来数字音乐收藏世界的新思路，创造出兼具未来科技感的Jay式音乐元宇宙。总是喜欢挑战与尝试新事物的周杰伦，如今将带着他满载且前所未见的音乐能量在薄盒首次启动专属的元宇宙，将属于周杰伦音乐创作的每一个音符、旋律、编曲、BEAT、歌词、画面，在区块链上进阶成为永不消逝的经典收藏。",
      btn1: "￥20",
      btn2: "￥499",
      btn11: "精装盲盒",
      btn22: "限量盲盒",
      ruleName: "活动规则",
      noTableData: "暂无数据",

      redT: {
        title: "JAY红色帽衫",
        info1: "购买精装盲盒或限量盲盒，可自动获得一套红色帽衫3D服装（可穿戴数字资产），每人上限1套。",
        info2: "限时不限量，只可在活动期间内获得。",
      },
      mns: {
        title: "MNS",
        info1: "元宇宙数字身份，购买精装盲盒或限量盲盒，可获得一个MNS名称0元名额，有效期截止活动结束。",
        info2: "",
      },
      poap: {
        title: "周杰伦音乐元宇宙先锋",
        info1: "获得任意钥匙后，在充分探索周杰伦音乐Demo空间时，且当你到达空间中的某个位置，即可获得一枚POAP徽章。",
        info2: "总徽章上线10万个，赠完为止。",
      },
    },
    rankPage: {
      index: "序号",
      user: "用户",
      operation: "用户操作",
      value: "能量值",
      dayValue: "今日能量值",
      countValue: "累计能量值",
      time: "下单时间",
      boxReward: "盲盒奖励",
      buyCount: "邀请购买总数人",
    }
  },
}



// WEBPACK FOOTER //
// ./src/i18n/config/zh-cn.js